import * as React from 'react';
import { inject, observer } from 'mobx-react';
import TrackVisibility from 'react-on-screen';

import ContainerInjectedMobx from './container';
import OnScreenContainer from './container/onScreen';

interface IArticleNewsListProps {

}

export default class ArticleNewsList extends React.Component<IArticleNewsListProps, {}> {
  private exposurePromise: Promise<any>;
  private exposureFunction;

  constructor(props) {
    super(props);
    [
      'getDomOnScreen',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });

    this.exposurePromise = new Promise<any>((resolve, reject) => {
      this.exposureFunction = () => {
        resolve();
      };
    });
  }

  public render(): React.ReactNode {
    const Clone = class CloneClass extends ContainerInjectedMobx {};
    const domOnScreen: React.ReactNode = this.getDomOnScreen();
    const WrappedComponent: any = inject((stores: any) => ({
      articleNewsListStore: stores.rootStore.articleNewsListStore,
      exposurePromise: this.exposurePromise,
    }))(observer(Clone));
    return (
      <div style={{ position: 'relative' }}>
        { domOnScreen }
        <WrappedComponent />
      </div>
    );
  }

  public getDomOnScreen(): React.ReactNode {
    const Clone = class CloneClass extends OnScreenContainer {};
    return (
      <TrackVisibility partialVisibility once>
      {({ isVisible }) => {
        const WrappedComponent: any = inject((stores: any) => ({
          isOnScreen: isVisible,
          onShowNewsList: stores.rootStore.articleNewsListStore.logShowNewsList,
          exposureFunction : this.exposureFunction,
        }))(observer(Clone));
        return (
          <WrappedComponent />
        );
      }}
      </TrackVisibility>
    );
  }

}
